import { useState } from 'react';
import { NJMenu } from '@engie-group/fluid-design-system-react';
import { UMIcon, UMR } from '../../../urbanmap/_components';

/** Same "⋮ → Modifier les légendes" entry as the production buildings legend. */
export function DensityLegendMenu({ onEdit, label = 'Canalisations' }: { onEdit: () => void; label?: string }) {
  const [opened, setOpened] = useState(false);
  return <NJMenu.Root opened={opened} onOpen={setOpened}>
    <NJMenu.Anchor>
      <button type="button" aria-label={`Options de la légende ${label}`} title="Options de la légende"
        aria-haspopup="menu" aria-expanded={opened}
        style={{ border: 'none', background: 'transparent', padding: 0, cursor: 'pointer', display: 'flex', flexShrink: 0 }}>
        <UMIcon name="more_vert" size={18} box={24} color={UMR.black} />
      </button>
    </NJMenu.Anchor>
    <NJMenu.Dropdown aria-label={`Options de la légende ${label}`}
      style={{ minWidth: 180, maxWidth: 'calc(100vw - 24px)', fontFamily: UMR.font }}>
      <NJMenu.Item label="Modifier les légendes" role="menuitem"
        style={{ padding: '4px 16px', width: '100%', textAlign: 'left', fontFamily: UMR.font, fontSize: 14, lineHeight: '21px' }}
        onClick={() => { setOpened(false); onEdit(); }}>
        Modifier les légendes
      </NJMenu.Item>
    </NJMenu.Dropdown>
  </NJMenu.Root>;
}
